// Tooltip — lightweight CSS-only tooltip on hover/focus. No
// portal, no positioning library — anchor-relative, top-aligned.

import { useState } from 'react'

export default function Tooltip({ label, children, side = 'top' }) {
  const [shown, setShown] = useState(false)

  const placement = side === 'bottom'
    ? { top: '100%', marginTop: 6, left: '50%', transform: 'translateX(-50%)' }
    : side === 'left'
    ? { right: '100%', marginRight: 6, top: '50%', transform: 'translateY(-50%)' }
    : side === 'right'
    ? { left: '100%', marginLeft: 6, top: '50%', transform: 'translateY(-50%)' }
    : { bottom: '100%', marginBottom: 6, left: '50%', transform: 'translateX(-50%)' }

  return (
    <span
      style={{ position: 'relative', display: 'inline-flex' }}
      onMouseEnter={() => setShown(true)}
      onMouseLeave={() => setShown(false)}
      onFocus={() => setShown(true)}
      onBlur={() => setShown(false)}
    >
      {children}
      {shown && label && (
        <span
          role="tooltip"
          style={{
            position: 'absolute',
            ...placement,
            background: 'var(--olv-elevated)',
            border: '1px solid var(--olv-panel-border)',
            color: 'var(--olv-text-primary)',
            padding: '5px 10px',
            borderRadius: 6,
            fontSize: 10,
            fontFamily: 'var(--font-mono)',
            whiteSpace: 'nowrap',
            zIndex: 300,
            pointerEvents: 'none',
            boxShadow: '0 4px 16px rgba(0,0,0,0.4)',
          }}
        >
          {label}
        </span>
      )}
    </span>
  )
}
